import '../assets/css/homePage.css'
import { useEffect, useRef, useState } from 'react'
import TopMenu from './TopMenu';
import { useInView } from "react-intersection-observer";
import LojaCard from './subComponents/LojaCard';
import GlobalVar from './subComponents/GlobalVar';
import VantagemCard from './subComponents/VantagemCard';
import Rodape from './Rodape';

import revendSmileSmallSize from '../assets/imgs/revendSmileSmallSize.jpg'
import revendSmileLargeSize from '../assets/imgs/revendSmileLargeSize.jpg'


//logoAnimation
var windowWidth = window.screen.availWidth;
var windowHeight = window.screen.availHewindowHeight;

export default function HomePage({ativaResp}){

    const [indexImg, setIndexImg] = useState(0);

    const imgRevendRef = useRef()
    const [imgRevendRefSize, setimgRevendRefSize] = useState({ width: 0, height: 0 });

    const lojaList = GlobalVar.lojas

    const [ inicioref, inicioInView ] = useInView({ triggerOnce: false});

    const [ cardBeneficioref, cardBeneficioInView ] = useInView({ triggerOnce: false, trackVisibility: true, delay: 100});

    const [ cardLojasRef, cardLojasInView ] = useInView({ triggerOnce: true});

    const [ cardLigaref, cardLigaInView ] = useInView({ triggerOnce: false, trackVisibility: true, delay: 100});

    useEffect(() => {
        // Aguarda um pequeno tempo para garantir que os elementos foram carregados
        setTimeout(() => {
          const hash = window.location.hash; // Pega o hash da URL (#CadastroRevend)
          if (hash) {
            const element = document.querySelector(hash); // Seleciona o elemento pelo ID
            if (element) {
              element.scrollIntoView({ behavior: "smooth" }); // Faz o scroll suave
            }
          }
        }, 300);
      }, []);
    


    useEffect(() => {
      if (imgRevendRef.current) {
        // Pegar as dimensões da div
        const { width, height } = imgRevendRef.current.getBoundingClientRect();
        setimgRevendRefSize({ width, height });
        console.log(width)
      }
    }, []);


    useEffect(()=>{
        document.getElementsByTagName('body')[0].className = "homePageBdy";
    },[])
    return <>
        <div className="containerPrincipal homePage" >

            <TopMenu />



            <div className="firstContent" ref={inicioref} 
                          style={{
                                  gridTemplateColumns: inicioInView ? '30% 40%' : '40% 60%'}}>
                <div className="logo">
                    <div className="logoImg"
                    style={{backgroundImage: ativaResp ?  `url(${revendSmileSmallSize})` : `url(${revendSmileLargeSize})`}}></div>
                </div>
                <div className="sejaRevend">
                    <div className="titleSide">SEJA UMA REVENDEDORA</div>
                    <div className="subTitleSide">Revenda produtos de alta qualidade e com boa lucratividade com a Babita</div>
                    {/* {ativaResp ? <></> : 
                    <div className="btnCad" onClick={()=>window.location.href = 'https://wa.me/5531986524600/?text=Ola!%20vim%20pelo%20Site%20da%20Babita%20e%20gostaria%20de%20revender'}>
                      Cadastre-se agora!</div>} */}
                </div>
            </div>

            {/* <div className="divisorHome1 divisorHome"></div> */}

                    <div id="beneficios" className="secondContent" ref={cardBeneficioref} style={{width: ativaResp? '100%' : (cardBeneficioInView ? '75%' : '100%')}}>
                        
                        <div className="cardBeneficio1 cardBeneficio"></div>
                        <div className="cardBeneficio2 cardBeneficio"></div>
                        <div className="cardBeneficio4 cardBeneficio"></div>
                        <div className="cardBeneficio3 cardBeneficio"></div>

                    </div>
                      <div className="btnCad" onClick={()=>window.location.href = 'https://wa.me/5531986524600/?text=Ola!%20vim%20pelo%20Site%20da%20Babita%20e%20gostaria%20de%20revender'}>
                        Cadastre-se agora!</div>
                
                {/* <div className="divisorHome2 divisorHome"></div> */}

            <div id="quemSomos" className="thirdContent">
                    <h2 className="title">Quem Somos</h2>
                    <p className="subTitle">Somos, desde 1982, Babita.</p>
                    <p className="text">Vendemos moda exclusivamente para revendedores e acreditamos que uma mulher bem vestida faz toda a diferença. <br />
                                        Por isso buscamos, todos os dias, produzir e oferecer o melhor do Fast Fashion mundial com as melhores condições 
                                        permitindo rentabilidade para nossos revendedores.<br />
                                        Oferecemos um grande mix de produtos que atendem mulheres de todos os estilos e de 
                                        todas as idades. O que nos move é vesti-las bem para que se sintam lindas e cheias de autoestima...
                    </p>
                    <div className="buttonSaibaMais" onClick={()=>window.location.href = 'https://babita.com.br/BoasVindas'}>Saiba mais sobre <br/>a nossa história</div>

            </div>

            {/* <div className="divisorHome4 divisorHome"></div>


            <div className="divisorHome5 divisorHome"></div> */}

            <div className={`FashionStars ${cardLigaInView ? 'viewCardFashion' : ''}`} ref={cardLigaref}>
              <div className="innerBorder"></div>
              {ativaResp ? <>
                <div className="starExperience" style={{'--topBubble': '-3vw', '--leftBubble': '-10vw', '--sizeBubble': '33vw'}}></div>
                <div className="starExperience" style={{'--topBubble': '-6vw', '--rightBubble': '-10vw', '--sizeBubble': '33vw'}}></div>
                <div className="starExperience" style={{'--topBubble': '30vw', '--leftBubble': '5vw', '--sizeBubble': '33vw'}}></div>
                <div className="starExperience" style={{'--topBubble': '70vw', '--rightBubble': '-5vw', '--sizeBubble': '33vw'}}></div>
                <div className="starExperience" style={{'--topBubble': '50%', '--leftBubble': '10vw', '--sizeBubble': '33vw'}}></div>
                <div className="starExperience" style={{'--topBubble': '68%', '--rightBubble': '-3vw', '--sizeBubble': '20vw'}}></div>
                <div className="starExperience" style={{'--bottomBubble': '5%', '--leftBubble': '-1vw', '--sizeBubble': '38vw'}}></div>
                <div className="starExperience" style={{'--bottomBubble': '-6vw', '--rightBubble': '3vw', '--sizeBubble': '20vw'}}></div>
              </> : <>
              <div className="starExperience" style={{'--topBubble': '-5%', '--leftBubble': '-5vh', '--sizeBubble': '20vh'}}></div>
                <div className="starExperience" style={{'--topBubble': '-6%', '--rightBubble': '-10vh', '--sizeBubble': '33vh'}}></div>
                <div className="starExperience" style={{'--topBubble': '60%', '--leftBubble': '-10vh', '--sizeBubble': '33vh'}}></div>
                <div className="starExperience" style={{'--topBubble': '10%', '--rightBubble': '60%', '--sizeBubble': '33vh'}}></div>
                <div className="starExperience" style={{'--topBubble': '60%', '--leftBubble': '50%', '--sizeBubble': '20vh'}}></div>
                <div className="starExperience" style={{'--topBubble': '68%', '--rightBubble': '-3vh', '--sizeBubble': '20vh'}}></div>
                <div className="starExperience" style={{'--topBubble': '5%', '--leftBubble': '60%', '--sizeBubble': '15vh'}}></div>
                {/* <div className="starExperience" style={{'--bottomBubble': '-6vh', '--rightBubble': '3vh', '--sizeBubble': '20vh'}}></div> */}
              </>}

              <div className="content">
                <div className="content1">
                  <div className="logoFashion"></div>
                </div>
                <div className="content2">
                  <div className="titleFashion">Faça parte da Liga Fashion Stars Babita!</div>
                  <div className="subTitle">Assine e tenha muito mais vantagens!</div>
                  <div className="beneficiosCard">
                    <div className="beneficio">• Extensão no Prazo das Trocas</div>
                    <div className="beneficio">• Seja uma das indicadas para receber clientes novos</div>
                    <div className="beneficio">• Frete 50% OFF*</div>
                    <div className="beneficio">• Desconto adicional em produtos</div>
                    <div className="beneficio mid">• Acesso a experiências exclusivas: Backstage das revistas Babita, convenções e muito mais…</div>
                    <div className="beneficio max">• Acesso antecipado a lançamentos e promoções no nosso app exclusivo.</div>
                  </div>
                <div className="obs">*Consulte uma de nossas gerentes ou clique abaixo e fale com o relacionamento para participar!</div>
                <div className="buttonFacaParteFashion" 
                            onClick={()=>window.location.href = 'https://wa.me/553186524600?text=Ol%C3%A1!%20vim%20pelo%20site%20da%20Babita%20e%20desejo%20saber%20um%20pouco%20mais%20sobre%20a%20Liga%20Fashion%20Stars!'}>
                              Faça Parte</div>
                </div>
              </div>
          
            </div>

          <div id="quemSomos" className="fourthContent">
                    <div className="title">@babitaoficial</div>
                    <div className="contents">
                      <div className="imgInsta imgInsta1" onClick={() => {window.location.href = 'https://www.instagram.com/p/DK-fLqoP2Do/?igsh=MXNwYTRrcjdlMWUxMQ%3D%3D'}}></div>
                      <div className="imgInsta imgInsta2" onClick={() => {window.location.href = 'https://www.instagram.com/babitaoficial/reel/DLqfmeusFpZ/'}}></div>
                      <div className="imgInsta imgInsta3" onClick={() => {window.location.href = 'https://www.instagram.com/p/DJ-CZvrvSY6/?igsh=MTRrcjZmdXV0eml0cA%3D%3D'}}></div>
                    </div>
          </div>


     


          <div id="lojasBabita" className="fifthContent" onClick={() => {window.location.href = 'https://encontrarrevendedora.babita.com.br/'}}>
              <div className="imgEncontrarRevend"></div>
          </div>
          



            <div id="lojasBabita" className="sixthContent" ref={cardLojasRef} style={!cardLojasInView ? { opacity: 0, transform: 'translateY(30%)'} : {opacity: 1, transform: 'translateY(0%)'}}>
                <h2 className="title">Conheça nossas Lojas</h2>
                <p className="subtitle">Nossas lojas funcionam de Terça a Sexta-Feira das 9h ás 18h, e as Segundas de 09h30 ás 18h</p>
                <div className="lojaCards">
                    {lojaList ? Object.keys(lojaList).map((val)=> <LojaCard infoLoja={lojaList[val]}/>)
                    : <></>}
                    
                </div>
            </div>

            <Rodape />
        </div>
    </>
}